import { action, computed, observable } from "mobx";
import * as UiStore from "../States/AreaUiInfo";
import { AppStore } from "./AppStore";
import { StateStorage } from "./StateStorage"

class UiRepositoryImpl {

	readonly USER_UI_INFO: string = "userUiInfo";
	readonly USERGROUP_UI_INFO: string = "userGroupUiInfo";
	readonly META_UI_INFO: string = "metaUiInfo";
	readonly COLLECTION_UI_INFO: string = "collectionUiInfo";
	readonly FILE_UI_INFO: string = "fileUiInfo";
	readonly EPUB_UI_INFO: string = "epubUiInfo";
	readonly BRANDING_UI_INFO: string = "brandingUiInfo";
	readonly READER_UI_INFO: string = "readerUiInfo";
	readonly TRANSLATION_UI_INFO: string = "translationUiInfo";
	readonly PORTAL_UI_INFO: string = "portalUiInfo";

	saveUiSettings = (key: string, areaUiStore: UiStore.AreaUiInfoImpl) => {
		StateStorage.saveData(key, JSON.stringify(areaUiStore));
	}

	get userUiInfo(): UiStore.AreaUiInfoImpl {
		let userUiInfo = StateStorage.getData(this.USER_UI_INFO);
		return userUiInfo ? JSON.parse(userUiInfo) : new UiStore.AreaUiInfoImpl(this.USER_UI_INFO);
	}

	get userGroupsUiInfo(): UiStore.AreaUiInfoImpl {
		let userGroupsUiInfo = StateStorage.getData(this.USERGROUP_UI_INFO);
		return userGroupsUiInfo ? JSON.parse(userGroupsUiInfo) : new UiStore.AreaUiInfoImpl(this.USERGROUP_UI_INFO);
	}

	get metaUiInfo(): UiStore.AreaUiInfoImpl {
		let metaUiInfo = StateStorage.getData(this.META_UI_INFO);
		return metaUiInfo ? JSON.parse(metaUiInfo) : new UiStore.AreaUiInfoImpl(this.META_UI_INFO);
	}

	get collectionUiInfo(): UiStore.AreaUiInfoImpl {
		let collectionUiInfo = StateStorage.getData(this.COLLECTION_UI_INFO);
		return collectionUiInfo ? JSON.parse(collectionUiInfo) : new UiStore.AreaUiInfoImpl(this.COLLECTION_UI_INFO);
	}

	get filesUiInfo(): UiStore.AreaUiInfoImpl {
		let filesUiInfo = StateStorage.getData(this.FILE_UI_INFO);
		return filesUiInfo ? JSON.parse(filesUiInfo) : new UiStore.AreaUiInfoImpl(this.FILE_UI_INFO);
	}

	get brandingUiInfo(): UiStore.AreaUiInfoImpl {
		let brandingUiInfo = StateStorage.getData(this.BRANDING_UI_INFO);
		return brandingUiInfo ? JSON.parse(brandingUiInfo) : new UiStore.AreaUiInfoImpl(this.BRANDING_UI_INFO);
	}

	get readerUiInfo(): UiStore.AreaUiInfoImpl {
		let readerUiInfo = StateStorage.getData(this.READER_UI_INFO);
		return readerUiInfo ? JSON.parse(readerUiInfo) : new UiStore.AreaUiInfoImpl(this.READER_UI_INFO);
	}

	get epubUiInfo(): UiStore.AreaUiInfoImpl {
		let epubUiInfo = StateStorage.getData(this.EPUB_UI_INFO);
		return epubUiInfo ? JSON.parse(epubUiInfo) : new UiStore.AreaUiInfoImpl(this.EPUB_UI_INFO);
	}

	get translationUiInfo(): UiStore.ExtendedAreaUiInfoImpl {
		let translationUiInfo = StateStorage.getData(this.TRANSLATION_UI_INFO);
		return translationUiInfo ? JSON.parse(translationUiInfo) : new UiStore.ExtendedAreaUiInfoImpl(this.TRANSLATION_UI_INFO);
	}

	get portalUiInfo(): UiStore.AreaUiInfoImpl {
		let portalUi= StateStorage.getData(this.PORTAL_UI_INFO);
		return portalUi ? JSON.parse(portalUi) : new UiStore.AreaUiInfoImpl(this.PORTAL_UI_INFO);
	}

	removeUserUiInfoSettings = () => {
		StateStorage.removeData(this.USER_UI_INFO);
	}

	removeUserGroupsUiSettings = () => {
		StateStorage.removeData(this.USERGROUP_UI_INFO);
	}

	removeMetaUiSettings = () => {
		StateStorage.removeData(this.META_UI_INFO);
	}

	removeCollectionUiSettings = () => {
		StateStorage.removeData(this.COLLECTION_UI_INFO);
	}

	removeBrandingUiSettings = () => {
		StateStorage.removeData(this.BRANDING_UI_INFO);
	}

	removeReaderUiSettings = () => {
		StateStorage.removeData(this.READER_UI_INFO);
	}

	removeTranslationUiSettings = () => {
		StateStorage.removeData(this.TRANSLATION_UI_INFO);
	}

	removePortalUiSettings = () => {
		StateStorage.removeData(this.PORTAL_UI_INFO);
	}
}

export var UiRepos = new UiRepositoryImpl();
